export const generateJoinUrl = (
	eventId: string,
	token?: string | null,
): string => {
	if (!eventId) return "";
	const baseUrl = window.location.origin;
	const encodedId = encodeURIComponent(eventId);
	if (token) {
		return `${baseUrl}/join?token=${encodeURIComponent(token)}`;
	}
	return `${baseUrl}/events/${encodedId}`; // Fallback to event page
};

/**
 * Generate a check-in URL for QR code display.
 * Users scan this to check in to an event.
 *
 * @param eventId - The event ID
 * @param token - Check-in claim token from create_checkin_claim()
 * @returns URL for check-in QR code
 */
export const generateCheckInUrl = (
	eventId: string,
	token?: string | null,
): string => {
	if (!eventId) return "";
	const baseUrl = window.location.origin;
	const encodedId = encodeURIComponent(eventId);
	if (token) {
		return `${baseUrl}/checkin?token=${encodeURIComponent(token)}`;
	}
	return `${baseUrl}/events/${encodedId}`; // Fallback to event page
};
